import { oc } from "@orpc/contract";
import { z } from "zod";
import {
  portalManagementContracts,
  RegeneratePortalAsJsonInputSchema,
  RegeneratePortalAsJsonOutputSchema,
} from "./portal-management.contract";

export const PortalInviteUserInputSchema = z.object({
  customerId: z.uuid(),
  email: z.string().email(),
  name: z.string().min(1),
});

export const PortalInviteUserOutputSchema = z.object({
  inviteUrl: z.string(),
});

export const portalInviteUserContract = oc
  .input(PortalInviteUserInputSchema)
  .output(PortalInviteUserOutputSchema)
  .route({
    method: "POST",
  });

export const regenerateAsJsonContract = oc
  .input(RegeneratePortalAsJsonInputSchema)
  .output(RegeneratePortalAsJsonOutputSchema)
  .route({
    method: "POST",
  });

export const portalContracts = {
  ...portalManagementContracts,
  inviteUser: portalInviteUserContract,
  regenerateAsJson: regenerateAsJsonContract,
} as const;

export type PortalInviteUserInput = z.infer<typeof PortalInviteUserInputSchema>;
export type PortalInviteUserOutput = z.infer<
  typeof PortalInviteUserOutputSchema
>;
